import { defineStore } from 'pinia'
import { ref } from 'vue'

export interface VideoChapter {
    name: string
    /** 跳转时间（秒） */
    time: number
}

export interface VideoModalOptions {
    src: string
    poster?: string
    title?: string
    autoplay?: boolean
    /** 富文本内容（HTML） */
    content?: string
    /** 章节列表，点击可跳转到对应视频时间 */
    chapters?: VideoChapter[]
}

export const useVideoModalStore = defineStore('videoModal', () => {
    const visible = ref(false)
    const videoSrc = ref('')
    const poster = ref('')
    const title = ref('')
    const autoplay = ref(true)
    const content = ref('')
    const chapters = ref<VideoChapter[]>([])

    function open(options: VideoModalOptions): void {
        videoSrc.value = options.src
        poster.value = options.poster || ''
        title.value = options.title || ''
        autoplay.value = options.autoplay ?? true
        content.value = options.content || ''
        chapters.value = Array.isArray(options.chapters) ? options.chapters : []
        visible.value = true
    }

    function close(): void {
        visible.value = false
        setTimeout(() => {
            videoSrc.value = ''
            poster.value = ''
            title.value = ''
            content.value = ''
            chapters.value = []
        }, 300)
    }

    return {
        visible,
        videoSrc,
        poster,
        title,
        autoplay,
        content,
        chapters,
        open,
        close
    }
})
